import { TColumItem } from '../components/types';

/**
 * Will return the value of a populated field
 *
 * @param {*} field field where to populated
 * @return {*}  {string}
 */
export const getPopulatedField = (field: string, item: TColumItem): string => {
    const parts = field.split('.');

    let response: any = item;

    for (const part of parts) {
        if (!response?.hasOwnProperty(part)) return '- - -';

        response = response[part];
    }

    return response;
};
